import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { abTestConfigInterface } from './interfaces/abTestConfig.interface';
import { CONFIG } from './injection-tokens';
import { AbTestVersionDirective } from './directives/abTestVersion.directive';
import { AbTestService } from './services/ab-test.service';

@NgModule({
  declarations: [
    AbTestVersionDirective
  ],
  exports: [
    AbTestVersionDirective
  ],
  imports: [
    CommonModule
  ]
})
export class AbTestModule {
  static forRoot(configs: abTestConfigInterface[]): ModuleWithProviders<AbTestModule> {
    return {
      ngModule: AbTestModule,
      providers: [
        AbTestService,
        { provide: CONFIG, useValue: configs }
      ]
    }
  }
}
